import { c as _c } from "react/compiler-runtime";
import { LocaleEnum, localeLabels } from '@systemeio/ui';
import React, { PropsWithChildren, memo } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { hexToRgbString } from 'shared/utils/hex-to-rgb-string';
import { CourseThemeColorSetInterface } from '../types/course-theme-color-set-interface';
import { ChevronDownIcon, CircleIcon, HomeIcon, PlayIcon, QuizIcon, RoundedCheckIcon } from '@systemeio/ui/icons';
export interface CourseThemePreviewProps {
  theme?: CourseThemeColorSetInterface;
  themeId: number;
}
function HeaderMenuElement(t0) {
  const $ = _c(5);
  const {
    children,
    hasChevron
  } = t0;
  let t1;
  if ($[0] !== hasChevron) {
    t1 = hasChevron && <ChevronDownIcon className="max-h-[4px] max-w-[4px]" />;
    $[0] = hasChevron;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <span className="flex items-center gap-1 text-[4px] font-bold leading-[6px]">{children}{t1}</span>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
const stabCourseContent = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras suscipit ac mauris et eleifend. Suspendisse sed pretium est. Integer iaculis, risus ut vestibulum vehicula, velit est fringilla risus, nec eleifend nibh arcu a lorem. ';
const progress = 30;
function CourseThemePreview(t0) {
  const $ = _c(119);
  const {
    theme
  } = t0;
  const {
    t,
    i18n
  } = useLocoTranslation();
  if (!theme) {
    return null;
  }
  let t1;
  if ($[0] !== theme.background) {
    t1 = {
      backgroundColor: theme.background
    };
    $[0] = theme.background;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = theme["header-background"];
  let t3;
  if ($[2] !== t2) {
    t3 = {
      backgroundColor: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="bg-sio_logo h-[10px] w-[10px] bg-contain" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <QuizIcon className="text-background-secondary max-h-[8px] max-w-[8px]" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t) {
    t6 = t("dashboard.courses.title_plural");
    $[6] = t;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <HeaderMenuElement>{t5}{t6}</HeaderMenuElement>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <HomeIcon className="fill-background-secondary max-h-[6px] max-w-[6px]" />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t) {
    t9 = t("global.dashboard");
    $[11] = t;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t9) {
    t10 = <HeaderMenuElement>{t8}{t9}</HeaderMenuElement>;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <HeaderMenuElement hasChevron={true}><div className="bg-user_stab_avatar h-[12px] w-[12px] bg-contain" /></HeaderMenuElement>;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const t12 = i18n?.language && localeLabels[i18n.language as LocaleEnum];
  let t13;
  if ($[16] !== t12) {
    t13 = <HeaderMenuElement hasChevron={true}>{t12}</HeaderMenuElement>;
    $[16] = t12;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t10 || $[19] !== t13 || $[20] !== t7) {
    t14 = <div className="flex items-center gap-2">{t7}{t10}{t11}{t13}</div>;
    $[18] = t10;
    $[19] = t13;
    $[20] = t7;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t14 || $[23] !== t3) {
    t15 = <div className="text-background-secondary flex h-5 w-full items-center justify-between px-2" style={t3}>{t4}{t14}</div>;
    $[22] = t14;
    $[23] = t3;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== theme.primary) {
    t16 = {
      color: theme.primary
    };
    $[25] = theme.primary;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t) {
    t17 = t("dashboard.course.theme.preview.course_name");
    $[27] = t;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t16 || $[30] !== t17) {
    t18 = <div className="px-2.5 pt-[2px]"><span className="text-[5px] font-bold" style={t16}>{t17}</span></div>;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  const t19 = theme["block-background"];
  let t20;
  if ($[32] !== t19 || $[33] !== theme.primary) {
    t20 = {
      backgroundColor: t19,
      color: theme.primary
    };
    $[32] = t19;
    $[33] = theme.primary;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="bg-instructor_stab_avatar h-[20px] w-[20px] bg-contain" />;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== t) {
    t22 = t("dashboard.course.theme.preview.instructor_name");
    $[36] = t;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== t22) {
    t23 = <div className="flex w-full flex-col items-center justify-center gap-1">{t21}<span className="text-[5px] leading-[6px]">{t22}</span></div>;
    $[38] = t22;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  if ($[40] !== theme.primary) {
    t24 = hexToRgbString(theme.primary, 0.25);
    $[40] = theme.primary;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== t24 || $[43] !== theme.primary) {
    t25 = {
      borderColor: t24,
      color: theme.primary
    };
    $[42] = t24;
    $[43] = theme.primary;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] !== t) {
    t26 = t("global.previous");
    $[45] = t;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  let t27;
  if ($[47] !== t25 || $[48] !== t26) {
    t27 = <div className="rounded-xs flex min-w-[30px] justify-center border-[1px] py-0  leading-[7px]" style={t25}>{t26}</div>;
    $[47] = t25;
    $[48] = t26;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  let t28;
  if ($[50] !== theme.secondary) {
    t28 = {
      backgroundColor: theme.secondary,
      borderColor: theme.secondary
    };
    $[50] = theme.secondary;
    $[51] = t28;
  } else {
    t28 = $[51];
  }
  let t29;
  if ($[52] !== t) {
    t29 = t("global.next");
    $[52] = t;
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  if ($[54] !== t28 || $[55] !== t29) {
    t30 = <div className="text-background-secondary rounded-xs flex min-w-[30px] justify-center border-[1px] py-0 leading-[7px]" style={t28}>{t29}</div>;
    $[54] = t28;
    $[55] = t29;
    $[56] = t30;
  } else {
    t30 = $[56];
  }
  let t31;
  if ($[57] !== t27 || $[58] !== t30) {
    t31 = <div className="flex items-center justify-evenly">{t27}{t30}</div>;
    $[57] = t27;
    $[58] = t30;
    $[59] = t31;
  } else {
    t31 = $[59];
  }
  const t32 = theme.primary;
  let t33;
  if ($[60] !== theme.primary) {
    t33 = hexToRgbString(theme.primary, 0.25);
    $[60] = theme.primary;
    $[61] = t33;
  } else {
    t33 = $[61];
  }
  let t34;
  if ($[62] !== t33 || $[63] !== theme.primary) {
    t34 = {
      color: t32,
      borderColor: t33
    };
    $[62] = t33;
    $[63] = theme.primary;
    $[64] = t34;
  } else {
    t34 = $[64];
  }
  let t35;
  if ($[65] !== theme.primary) {
    t35 = {
      width: `${progress}%`,
      backgroundColor: theme.primary
    };
    $[65] = theme.primary;
    $[66] = t35;
  } else {
    t35 = $[66];
  }
  let t36;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <div style={{
      width: `${100 * (progress / 100)}%`
    }} />;
    $[67] = t36;
  } else {
    t36 = $[67];
  }
  let t37;
  if ($[68] !== t35) {
    t37 = <div className="absolute inset-0 h-full max-h-[5px] overflow-hidden rounded-xl" style={t35}>{t36}</div>;
    $[68] = t35;
    $[69] = t37;
  } else {
    t37 = $[69];
  }
  let t38;
  if ($[70] !== t34 || $[71] !== t37) {
    t38 = <div className="relative flex max-h-[5px] w-full items-center justify-center overflow-hidden rounded-xl border-[1px] pt-[1px] text-center text-[3px] font-semibold" style={t34}>{t37}{progress}%</div>;
    $[70] = t34;
    $[71] = t37;
    $[72] = t38;
  } else {
    t38 = $[72];
  }
  let t39;
  if ($[73] !== t || $[74] !== theme.disabled || $[75] !== theme.primary || $[76] !== theme.secondary) {
    t39 = <ul className="customScroll customScrollThin overflow-y-auto overflow-x-hidden pl-1 leading-[10px] tracking-tighter" onScroll={_temp}>{Array.from({
        length: 2
      }, (_, i) => <li key={i}><span style={{
          color: i === 0 ? theme.primary : theme.disabled
        }}>{t("dashboard.course.theme.preview.module", {
            number: i + 1
          })}</span><ul className="pl-1">{Array.from({
            length: 3
          }, (__0, j) => <li key={j} className="flex items-center gap-[2px]" style={{
            color: i > 0 ? theme.disabled : j < 2 ? theme.primary : theme.secondary
          }}>{i === 0 && j < 2 ? <RoundedCheckIcon className="max-h-[4px] max-w-[4px]" /> : <CircleIcon className="max-h-[4px] max-w-[4px]" />}{t("dashboard.course.theme.preview.lecture", {
              number: j + 1
            })}</li>)}{i === 0 && <li className="flex items-center gap-[2px]" style={{
            color: theme.primary
          }}><QuizIcon className="max-h-[6px] max-w-[6px]" />{t("dashboard.course.theme.preview.quiz")}</li>}</ul></li>)}</ul>;
    $[73] = t;
    $[74] = theme.disabled;
    $[75] = theme.primary;
    $[76] = theme.secondary;
    $[77] = t39;
  } else {
    t39 = $[77];
  }
  let t40;
  if ($[78] !== t20 || $[79] !== t23 || $[80] !== t31 || $[81] !== t38 || $[82] !== t39) {
    t40 = <div className="row-span-3 flex max-h-[9.4rem] flex-col gap-1 rounded-[4px] p-2" style={t20}>{t23}{t31}{t38}{t39}</div>;
    $[78] = t20;
    $[79] = t23;
    $[80] = t31;
    $[81] = t38;
    $[82] = t39;
    $[83] = t40;
  } else {
    t40 = $[83];
  }
  const t41 = theme["block-background"];
  let t42;
  if ($[84] !== t41) {
    t42 = {
      backgroundColor: t41
    };
    $[84] = t41;
    $[85] = t42;
  } else {
    t42 = $[85];
  }
  let t43;
  if ($[86] !== t) {
    t43 = t("dashboard.course.theme.preview.lecture", {
      number: 3
    });
    $[86] = t;
    $[87] = t43;
  } else {
    t43 = $[87];
  }
  let t44;
  if ($[88] !== t43) {
    t44 = <span className="font-bold">{t43}</span>;
    $[88] = t43;
    $[89] = t44;
  } else {
    t44 = $[89];
  }
  let t45;
  let t46;
  if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <div className="from-text-tertiary relative h-[68px] w-[121px] self-center rounded-sm bg-gradient-to-b to-black"><PlayIcon className="text-background-tertiary absolute left-[50%] top-[50%] h-5 w-5 translate-x-[-50%] translate-y-[-50%]" /></div>;
    t46 = <div className="text-[3px] leading-[4px]">{stabCourseContent}</div>;
    $[90] = t45;
    $[91] = t46;
  } else {
    t45 = $[90];
    t46 = $[91];
  }
  let t47;
  if ($[92] !== t42 || $[93] !== t44) {
    t47 = <div className="text-text-primary flex flex-col gap-3 rounded-[4px] p-2 text-[7px] leading-[7px]" style={t42}>{t44}{t45}{t46}</div>;
    $[92] = t42;
    $[93] = t44;
    $[94] = t47;
  } else {
    t47 = $[94];
  }
  const t48 = theme["block-background"];
  let t49;
  if ($[95] !== t48) {
    t49 = {
      backgroundColor: t48
    };
    $[95] = t48;
    $[96] = t49;
  } else {
    t49 = $[96];
  }
  let t50;
  if ($[97] !== theme.primary) {
    t50 = hexToRgbString(theme.primary, 0.25);
    $[97] = theme.primary;
    $[98] = t50;
  } else {
    t50 = $[98];
  }
  let t51;
  if ($[99] !== t50 || $[100] !== theme.primary) {
    t51 = {
      borderColor: t50,
      color: theme.primary
    };
    $[99] = t50;
    $[100] = theme.primary;
    $[101] = t51;
  } else {
    t51 = $[101];
  }
  let t52;
  if ($[102] !== t) {
    t52 = t("dashboard.course.theme.preview.action.complete");
    $[102] = t;
    $[103] = t52;
  } else {
    t52 = $[103];
  }
  let t53;
  if ($[104] !== t51 || $[105] !== t52) {
    t53 = <div className="rounded-xs flex min-w-[25px] justify-center border-[1px] px-1 py-0 leading-[7px]" style={t51}>{t52}</div>;
    $[104] = t51;
    $[105] = t52;
    $[106] = t53;
  } else {
    t53 = $[106];
  }
  let t54;
  if ($[107] !== t49 || $[108] !== t53) {
    t54 = <div className="flex items-center justify-center rounded-[4px] p-2" style={t49}>{t53}</div>;
    $[107] = t49;
    $[108] = t53;
    $[109] = t54;
  } else {
    t54 = $[109];
  }
  let t55;
  if ($[110] !== t40 || $[111] !== t47 || $[112] !== t54) {
    t55 = <div className="grid max-h-40 grid-cols-[5rem_1fr] grid-rows-[1fr_1.2rem_1fr] gap-2 overflow-hidden px-2 pt-[1px]">{t40}{t47}{t54}</div>;
    $[110] = t40;
    $[111] = t47;
    $[112] = t54;
    $[113] = t55;
  } else {
    t55 = $[113];
  }
  let t56;
  if ($[114] !== t1 || $[115] !== t15 || $[116] !== t18 || $[117] !== t55) {
    t56 = <div className="bg-text-primary font-inter text-background-secondary h-48 w-full text-[4px] leading-[8px]" style={t1} role="img">{t15}{t18}{t55}</div>;
    $[114] = t1;
    $[115] = t15;
    $[116] = t18;
    $[117] = t55;
    $[118] = t56;
  } else {
    t56 = $[118];
  }
  return t56;
}
function _temp(e) {
  return e.preventDefault();
}
export default memo(CourseThemePreview, (prevProps, nextProps) => prevProps.themeId === nextProps.themeId);